export const ar = {
    // Login screen
    modal_login_capital: 'تسجيل الدخول',
    placeholder_email_address: 'البريد الإلكتروني',
    placeholder_password: 'كلمة المرور',
    tooltip_forgot_password: 'هل نسيت كلمة المرور؟',
    log_in: 'تسجيل الدخول',

    // Register screen
    modal_signup_capital: 'التسجيل',
    placeholder_repeat_password: 'أعد إدخال كلمة المرور',
    agree: ' أوافق على ',
    terms: 'الشروط',
    modal_register_capital: 'تسجيل',
    full_name: 'الاسم الكامل',

    // Price options
    choose_price: 'اختر السعر المناسب',
    subscription_price: 'اشتراك',
    asset_price: 'الأصول',
    paywall_subscription_text: 'يمكنك إلغاء اشتراكك في أي وقت',
    modal_back: 'العودة',
    next_button: 'التالي',

    // Payments screen
    pay: 'الدفع',
    pay_with: 'الدفع عن طريق  Paypal',
    credit_card: 'بطاقة الائتمان',
    payment_pay: 'ادفع',
    payment_price: 'السعر',
    placeholder_voucher_code: 'رمز قسيمة الشراء',
    placeholder_voucher: 'إدخال الرمز',
    card_number: 'رقم البطاقة',
    cardholder_name: 'اسم حامل البطاقة',

    // Forgot password
    forgot_pass_text:
        'سنرسل رابطًا إلى بريدك الإلكتروني لإعادة تعيين كلمة المرور',
    remember_pass: 'هل تتذكر كلمة المرور؟',
    reset: 'إعادة التعيين',

    // Set new password
    modal_enter_your_new_password: 'أدخل كلمة المرور الجديدة.',
    modal_please_check_your_email:
        'يرجى التحقق من بريدك الإلكتروني ونسخ الرمز المرفق من أجل المتابعة.',
    placeholder_token: 'الرمز',
    new_password: 'كلمة المرور الجديدة',
    repeat_new_password: 'أعد إدخال كلمة المرور الجديدة',
    cancel: 'إلغاء ',
    set: 'تعيين',

    // Change password
    update: 'تحديث',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'حسابي',
    member_since: 'مشترك منذ',
    purchases: 'مشترياتي',
    subscriptions: 'اشتراكاتي',
    account_details: 'تفاصيل الحساب',
    export_data: 'نقل بياناتي',
    delete_account: 'حذف الحساب',

    // Purchases/Subscriptions
    purchases_link: 'المشتريات',
    subscriptions_link: 'الاشتراكات',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'تاريخ المشتريات',
    purchased: 'تم شراؤه',
    name: 'الاسم',
    active: 'فعَّال',
    inactive: 'غير نشط',
    canceled: 'تم إلغاؤه',
    type: 'النوع',
    next_transaction: 'المعاملة التالية',
    cancel_subscription: 'إلغاء الاشتراك >',
    subscriptions_active: 'الاشتراكات الفعالة',
    expires_at: 'تاريخ الانتهاء',
    no_more_subscriptions: 'ليست هناك المزيد من الاشتراكات',
    no_available_subscriptions: 'ليست هناك اشتراكات متاحة',
    no_more_active_accesses: 'ليست هناك المزيد من صلاحيات الوصول الفعالة',
    no_more_inactive_accesses: 'ليست هناك المزيد من صلاحيات الوصول غير الفعالة',
    no_available_active_accesses: 'ليست هناك صلاحيات وصول فعالة متاحة',
    no_available_inactive_accesses: 'ليست هناك صلاحيات وصول غير فعالة متاحة',
    subscription: 'الاشتراكات',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the ',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the ',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end:',

    // Export data screen
    export_question: 'هل تريد فعلًا نسخ بيانات حسابك؟',
    export: 'نسخ',
    first_export:
        'تقوم خاصية نسخ بيانات الحساب بإعداد نسخة من جميع البيانات الشخصية لحسابك، بما فيها:',
    second_export: 'بياناتك الشخصية',
    third_export: ' قائمة بعمليات تسجيل الدخول',
    fourth_export: 'قائمة باشتراكاتك',
    fifth_export: 'قائمة بعمليات الدفع',
    sixth_export: 'قائمة بصلاحيات وصولك إلى المحتوى المميز',
    last_export: 'يتم إرسال هذه النسخة إلى بريدك الإلكتروني على هيئة ملف مرفق',

    // Delete account screen
    delete_question: 'هل ترغب حقًا في حذف الحساب؟',
    delete: 'حذف',
    confirm: 'تأكيد',
    first_delete:
        'يترتب على إجراء حذف الحساب التخلص من كافة بياناتك الشخصية على النظام، بما فيها:',
    second_delete: ' البيانات الشخصية التي قمت بإدخالها أثناء عملية التسجيل.',
    third_delete:
        ' بيانات موقعك ومعلومات جهازك التي نجمعها أثناء عملية التحقق.',
    fourth_delete: ' جميع البيانات الأخرى المخزنة على قاعدة بياناتنا',
    fifth_delete:
        'البيانات التي نحتفظ بها بعد الحذف فقط هي تلك المتعلقة بالمعاملات والاشتراكات، طبقًا للقوانين التي نخضع لها',
    sixth_delete:
        'بالإضافة إلى حذف البيانات، سيتم كذلك تعطيل حسابك، مما يعني إلغاء جميع الاشتراكات وصلاحيات الوصول إلى الأصول، وإنهاء جميع الجلسات بما فيها الجلسة الحالية. لن يكون باستطاعتك بعد الآن شراء الأصول عبر هذا الموقع، ولن تكون بياناتك متاحة بأي وسيلة لفريق عملنا.',
    seventh_delete:
        'يستغرق إتمام هذا الإجراء يومًا أو اثنين، بعدها ستصلك رسالة تأكيد عبر بريدك الإلكتروني، ثم يتم حذف بريدك الإلكتروني أيضًا من قاعدة بياناتنا.',

    // Inputs validation
    required_field: 'حقل مطلوب',
    email_field: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    number_field: 'هذا الحقل لا يقبل إلا أرقامًا فقط',
    matchPass: 'كلمة المرور غير مطابقة',
    minpass_field: 'يجب ألا يقل طول كلمة المرور عن 8 حروف',
    minname_field: 'يجب ألا يقل طول الاسم عن حرفين',

    // Footer
    modal_terms: 'المزيد',
    modal_privacy: 'الخصوصية',
    modal_more: 'المزيد',
    modal_faq: 'الأسئلة الشائعة',
    modal_protected: 'ما هذا؟',
    logout: 'تسجيل الخروج',
    details: 'التفاصيل',
    preview_protected_by_inplayer: 'تحت حماية',
    modal_support: 'Support',

    dlc_download: 'تحميل',
};



// WEBPACK FOOTER //
// ./src/i18n/arabic.js